module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "main-container is-desktop columns"
  }, [_c('div', {
    staticClass: "no-pd-right-desktop pb-0 column-no-pad-mobile",
    class: {
      'is-two-thirds-desktop': !_vm.narrowVideoMode, 'is-6': _vm.narrowVideoMode
    }
  }, [_c('div', {
    staticClass: "box mb-0 pb-2 br-bottom-0"
  }, [_c('section', [(_vm.video && _vm.video.processed) ? _c('VideoPlayer', {
    ref: "video",
    attrs: {
      "src": _vm.video.url,
      "comments": _vm.video.comments,
      "narrowVideoMode": _vm.narrowVideoMode
    },
    on: {
      "currentTime": function($event) {
        _vm.updateCurrentTime($event)
      },
      "duration": function($event) {
        _vm.duration = $event
      }
    }
  }) : (!_vm.video.processed && !_vm.video.transcode_error) ? _c('div', {
    staticClass: "player-height video-placeholder-container "
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("Video successfully uploaded!")]), _vm._v(" "), _c('p', {
    staticClass: "title is-2"
  }, [_vm._v("Video Processing (Note this can sometimes take a while)")]), _vm._v(" "), _c('Loader')], 1) : (!_vm.video.processed && _vm.video.transcode_error) ? _c('div', {
    staticClass: "player-height video-placeholder-container "
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("There was an error converting your video")]), _vm._v(" "), _c('p', {
    staticClass: "title is-2"
  }, [_vm._v("please delete this video and try again")]), _vm._v(" "), (_vm.isOwner && (_vm.video.processed || _vm.video.transcode_error)) ? _c('input', {
    staticClass: "button is-danger",
    attrs: {
      "type": "button",
      "value": "delete",
      "name": "delete"
    },
    on: {
      "click": function($event) {
        _vm.showDeleteVideoModal = true
      }
    }
  }) : _vm._e()]) : (_vm.video == null) ? _c('div', {
    staticClass: "video-placeholder-container"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("Sorry, we couldn't find this video. It either doesn't exist, or it hasn't been shared with you.")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tarp pt-2"
  }, [(_vm.editing) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('vue-slider', {
    attrs: {
      "value": _vm.slider.value,
      "min": _vm.slider.min,
      "max": _vm.slider.max,
      "disabled": _vm.slider.disabled,
      "show": _vm.slider.show,
      "formatter": _vm.clipperTimeStampFormatter
    },
    on: {
      "change": _vm.handleSliderChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-space-between flex-align-center start-end-container"
  }, [_c('section', {
    staticClass: "flex-column"
  }, [_c('span', {
    staticClass: "is-bold"
  }, [_vm._v("Start")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("prettyCommentTime")(_vm.sliderStartTime)))])]), _vm._v(" "), _c('section', {
    staticClass: "flex-column"
  }, [_c('span', {
    staticClass: "is-bold"
  }, [_vm._v("Trimmed Length")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("prettyCommentTime")(_vm.sliderEndTime - _vm.sliderStartTime)))])]), _vm._v(" "), _c('section', {
    staticClass: "flex-column flex-end"
  }, [_c('span', {
    staticClass: "is-bold"
  }, [_vm._v("End")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("prettyCommentTime")(_vm.sliderEndTime)))])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-space-between flex-align-center"
  }, [_c('button', {
    staticClass: "button is-warning white-btn-text",
    class: _vm.clippingVideo && 'is-loading',
    attrs: {
      "disabled": !_vm.trimmable,
      "data-balloon": _vm.trimmable ? 'Cut the size of video' : 'This video is not trimmable because it isn\'t the original.',
      "data-balloon-pos": "right"
    },
    on: {
      "click": function($event) {
        _vm.clipVideo({
          replace: true
        })
      }
    }
  }, [_vm._v("\n                Trim Original Video\n              ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.video.url,
      "download": ""
    }
  }, [(_vm.downloadable) ? _c('button', {
    staticClass: "button is-info white-btn-text"
  }, [_vm._v("\n                  Download Video\n                ")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "button is-info",
    class: _vm.clippingVideo && 'is-loading',
    attrs: {
      "disabled": !_vm.clippable,
      "data-balloon": !_vm.clippable && 'Modify video length to enable.',
      "data-balloon-pos": "left"
    },
    on: {
      "click": function($event) {
        _vm.clipVideo({
          replace: false
        })
      }
    }
  }, [_vm._v("\n                Make New Clip\n              ")])])], 1) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "flex-space-between align-items-center flex-nowrap",
    class: {
      'mb-4': _vm.editing, 'bottom-border': !_vm.editing
    }
  }, [(!_vm.editing) ? _c('h2', {
    staticClass: "video-title mb-0",
    attrs: {
      "title": _vm.video.title
    }
  }, [_c('i', [_vm._v(_vm._s(_vm.video.title))])]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "flex-grow"
  }, [_c('input', {
    ref: "title",
    staticClass: "input is-medium",
    attrs: {
      "type": "text",
      "placeholder": "title"
    },
    domProps: {
      "value": _vm.video.title
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.video.transcode_error) ? _c('div', {
    staticClass: "editing-container"
  }, [(!_vm.editing && !_vm.isOwner) ? _c('div', {
    staticClass: "flex-grow"
  }, [_c('input', {
    staticClass: "button is-link",
    attrs: {
      "type": "button",
      "value": "remove",
      "name": "remove"
    },
    on: {
      "click": function($event) {
        _vm.showRemoveVideoModal = true
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.video.url,
      "download": ""
    }
  }, [(!_vm.editing && ((_vm.isGroupAdmin && !_vm.isOwner) || _vm.downloadOverride)) ? _c('button', {
    staticClass: "button is-info white-btn-text"
  }, [_vm._v("\n                  Download Video\n                ")]) : _vm._e()]), _vm._v(" "), (!_vm.editing && _vm.isOwner) ? _c('input', {
    staticClass: "button is-link",
    attrs: {
      "type": "button",
      "value": "edit",
      "name": "edit"
    },
    on: {
      "click": function($event) {
        _vm.editing = !_vm.editing
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.editing && (_vm.isOwner || _vm.isCoachWhoCanShare)) ? _c('input', {
    staticClass: "button is-info",
    attrs: {
      "type": "button",
      "value": "share",
      "name": "share"
    },
    on: {
      "click": function($event) {
        _vm.toggleShowShareModal()
      }
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.editing) ? _c('section', {
    staticClass: "mb-4"
  }, [_c('textarea', {
    directives: [{
      name: "textautosize",
      rawName: "v-textautosize"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "textarea",
    attrs: {
      "type": "text",
      "placeholder": "Add a description..."
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]) : _c('section', [_c('span', {
    staticClass: "d-flex align-items-center mt-1 mb-4"
  }, [_c('hr'), _vm._v(" "), _c('img', {
    staticClass: "user-profile-image m-0 mr-3",
    attrs: {
      "src": _vm.video.user.avatar_url
    }
  }), _vm._v(" "), _c('div', [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.video.user.name || _vm.video.user.email))])]), _vm._v(" "), _c('div', [_c('em', [_vm._v(_vm._s(_vm._f("formatTextDate")(_vm.video.created_on)))])])])]), _vm._v(" "), (_vm.video.description && !_vm.video.transcode_error) ? _c('h2', {
    staticClass: "subtitle line-breaks"
  }, [_vm._v("\n              " + _vm._s(_vm.video.description) + "\n            ")]) : (!_vm.video.transcode_error) ? _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("\n              No video description. "), (_vm.isOwner) ? _c('span', [_vm._v("Select "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("edit")]), _vm._v(" to add one.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.editing && _vm.video && _vm.video.folder && _vm.currentFolder != null && _vm.currentFolder.title) ? _c('div', {
    staticClass: "d-flex align-items-center text-muted"
  }, [_c('FolderIcon'), _vm._v(" "), _c('span', {
    attrs: {
      "data-balloon": _vm.currentFolder != null && _vm.currentFolder.description != null && _vm.currentFolder.description !== 'blank' ? ("description: " + (_vm.currentFolder.description)) : 'no description',
      "data-balloon-pos": "down"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.currentFolder.title) + "\n              ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.video.tags), function(tag) {
    return _c('span', {
      staticClass: "tag is-primary"
    }, [_vm._v(_vm._s(tag.text))])
  })], 2), _vm._v(" "), (_vm.editing) ? _c('section', {
    staticClass: "d-flex align-items-center mb-2 flex-wrap"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "mr-2 ml-2 text-bold bold"
  }, [_vm._v("Comment Visibility")]), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    on: {
      "change": function($event) {
        _vm.updateCommenting($event, _vm.videoID)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "S"
    },
    domProps: {
      "selected": _vm.video.commenting === 'S'
    }
  }, [_vm._v("Standard")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "P"
    },
    domProps: {
      "selected": _vm.video.commenting === 'P'
    }
  }, [_vm._v("Private")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    },
    domProps: {
      "selected": _vm.video.commenting === 'D'
    }
  }, [_vm._v("Disabled")])])])]), _vm._v(" "), _c('Dropdown', {
    staticClass: "ml-2",
    attrs: {
      "title": '?'
    }
  }, [_c('ul', [_c('li', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Standard")]), _vm._v(" Everyone can view comments")]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Private")]), _vm._v(" Users only view their comments and the video owner sees all comments")]), _vm._v(" "), _c('li', {
    staticClass: "mb-1"
  }, [_c('strong', [_vm._v("Disabled")]), _vm._v(" No comments are visible")])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('section', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "d-flex align-items-center flex-wrap"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "mr-2 ml-2 bold"
  }, [_vm._v("Current Folder")]), _vm._v(" "), (_vm.currentFolder && _vm.currentFolder.title) ? _c('a', {
    staticClass: "mr-2 tag is-medium",
    attrs: {
      "href": _vm.currentFolder.id && ("/folders/" + (_vm.currentFolder.id)),
      "data-balloon": _vm.currentFolder.description != null && _vm.currentFolder.description !== 'blank' ? ("description: " + (_vm.currentFolder.description)) : null,
      "data-balloon-pos": "down"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.currentFolder.title) + "\n                ")]) : _c('span', {
    staticClass: "mr-2 text-muted"
  }, [_vm._v("none")]), _vm._v(" "), _c('button', {
    staticClass: "button mr-4 is-link",
    on: {
      "click": function($event) {
        _vm.showMoveToFolderModal = true
      }
    }
  }, [_vm._v(_vm._s(_vm.video.folder != null ? 'Change Folder' : 'Move to Folder') + "\n                ")])])])]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('section', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "flex-grow"
  }, [(_vm.isOwner && (_vm.video.processed || _vm.video.transcode_error)) ? _c('input', {
    staticClass: "button is-link",
    attrs: {
      "type": "button",
      "value": "delete",
      "name": "delete"
    },
    on: {
      "click": function($event) {
        _vm.showDeleteVideoModal = true
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.isOwner) ? _c('input', {
    staticClass: "button is-link ",
    attrs: {
      "type": "button",
      "value": "cancel",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.editing = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isOwner) ? _c('input', {
    staticClass: "button is-success ",
    attrs: {
      "type": "button",
      "value": "save",
      "name": "save"
    },
    on: {
      "click": function($event) {
        _vm.updateVideo(_vm.videoID)
      }
    }
  }) : _vm._e()])]) : _vm._e()])]), _vm._v(" "), (!_vm.video.transcode_error && !_vm.narrowVideoMode) ? _c('div', {
    staticClass: "box background-light br-top-0 mb-0"
  }, [_c('div', {
    staticClass: "flex-space-between"
  }, [_c('h2', {
    staticClass: "is-size-4 fw-500"
  }, [_vm._v("Video Resources")]), _vm._v(" "), _c('input', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.video == null,
      "type": "button",
      "value": "Attach Resource",
      "name": "Attach Resource"
    },
    on: {
      "click": function($event) {
        _vm.toggleShowAddFileModal()
      }
    }
  })]), _vm._v(" "), (_vm.resources != null && _vm.resources.length > 0) ? _c('ul', _vm._l((_vm.resources), function(resource) {
    return _c('Resource', {
      key: resource.id,
      attrs: {
        "id": resource.id,
        "url": resource.url,
        "title": resource.title,
        "videoID": _vm.videoID
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.resources != null && _vm.resources.length === 0) ? _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No attached resources. Select the "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Attach Resource")]), _vm._v(" button to add some.")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.hasObservationsPerm) ? _c('button', {
    staticClass: "button is-warning mt-2",
    on: {
      "click": function($event) {
        _vm.narrowVideoMode = !_vm.narrowVideoMode
      }
    }
  }, [_vm._v(_vm._s(_vm.obsButtonLabel))]) : _vm._e()])]), _vm._v(" "), (!_vm.video.transcode_error && !_vm.narrowVideoMode) ? _c('div', {
    staticClass: "column-no-pad-mobile"
  }, [(_vm.video.commenting == 'D') ? _c('h3', {
    staticClass: "title is-4 box"
  }, [_vm._v("Comments are disabled")]) : _vm._e(), _vm._v(" "), (_vm.video.commenting == 'P') ? _c('h3', {
    staticClass: "title is-4 box"
  }, [_vm._v("Comments are set to private. You will only see your own.")]) : _vm._e(), _vm._v(" "), (_vm.video.commenting != 'D' && !_vm.narrowVideoMode) ? _c('Comments', {
    attrs: {
      "videoID": _vm.videoID,
      "currentTime": _vm.currentTime,
      "video": _vm.video,
      "comments": _vm.video.comments
    },
    on: {
      "pause": function($event) {
        _vm.handlePause()
      }
    }
  }) : _vm._e()], 1) : _c('div', {
    staticClass: "column is-6 pl-2"
  }, [_c('ArtsFormComments', {
    attrs: {
      "videoID": _vm.videoID,
      "currentTime": _vm.currentTime
    }
  })], 1)]), _vm._v(" "), (_vm.showAddFileModal) ? _c('AddFileModal', {
    attrs: {
      "videoID": _vm.videoID
    }
  }) : _vm._e(), _vm._v(" "), _c('Confirm', {
    attrs: {
      "title": "Deleting Video",
      "message": "Are you sure you want to delete the video?",
      "show": _vm.showDeleteVideoModal
    },
    on: {
      "cancel": function($event) {
        _vm.showDeleteVideoModal = false
      },
      "confirm": function($event) {
        _vm.deleteVideo()
      }
    }
  }), _vm._v(" "), _c('Confirm', {
    attrs: {
      "title": "Remove Video From My List",
      "message": "Are you sure you want to remove this shared video from your list?",
      "show": _vm.showRemoveVideoModal,
      "completeButtonText": 'Remove'
    },
    on: {
      "cancel": function($event) {
        _vm.showRemoveVideoModal = false
      },
      "confirm": function($event) {
        _vm.removeVideo()
      }
    }
  }), _vm._v(" "), _c('TransitionFade', [(_vm.isOwner || _vm.isCoachWhoCanShare) ? _c('ShareModal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showShareModal),
      expression: "showShareModal"
    }],
    attrs: {
      "video": _vm.video
    },
    on: {
      "close": _vm.closeShareModal
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showMoveToLibraryModal && _vm.isOwner) ? _c('MovetoLibraryModal', {
    attrs: {
      "videoID": _vm.videoID
    },
    on: {
      "close": function($event) {
        _vm.showMoveToLibraryModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('MoveToFolderModal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMoveToFolderModal && _vm.isOwner),
      expression: "showMoveToFolderModal && isOwner"
    }],
    attrs: {
      "video": _vm.video
    },
    on: {
      "close": function($event) {
        _vm.showMoveToFolderModal = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-38986a1a"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoBase.vue
// module id = 1006
// module chunks = 0